import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import TwoLevel from "../Menu/TwoLevel"; 

const OneLevel = ({ menu, pathname }) => {
  const [active, setActive] = useState(false);

  const { name, Svg, subMenu, highlight, subHighlight } = menu;

  const paths = subMenu.map((sub) => sub.path);

  useEffect(() => {
    if (
      paths.includes(pathname) ||
      paths.includes("/" + pathname.split("/")[1]) ||
      highlight.includes(pathname) ||
      subHighlight.includes(pathname.split("/").slice(0, 3).join("/"))
    ) {
      setActive(true);
    } else {
      setActive(false);
    }
  }, [pathname]);
  const handleClick = (e) => {
    e.stopPropagation();
    setActive((prev) => !prev); 
  };
  return (
    <li
      id={`collapse-menu-main ${name}-toggle-7`}
      className={`menu-item menu-item-submenu ${active ? "menu-item-open" : ""}`}
      data-menu-toggle="hover"
      // onClick={() => setActive((prev) => !prev)}
      onClick={handleClick}
    >
      <a className="menu-link menu-toggle">
        <span className="svg-icon menu-icon">
          <Svg />
        </span>
        <span className="menu-text">{name}</span>
        <i className="menu-arrow"></i>
      </a>
      <div className="menu-submenu">
        <i className="menu-arrow"></i>
        <ul className="menu-subnav">
          <li className="menu-item menu-item-parent">
            <span className="menu-link">
              <span className="menu-text">{name}</span>
            </span>
          </li>
          {subMenu.map((submenuItem, index) =>
            submenuItem.subMenu ? ( // If the submenu has another level, use the TwoLevelMenu
              <TwoLevel key={index} menu={submenuItem} pathname={pathname} />
            ) : (
              <li
                key={index}
                className={`menu-item ${
                  submenuItem.path === pathname ||
                  submenuItem.highlight.includes(pathname) ||
                  submenuItem.subHighlight.includes(
                    pathname.split("/").slice(0, 3).join("/")
                  )
                    ? "menu-item-open"
                    : ""
                }`}
              >
                <Link to={submenuItem.path} className="menu-link" >
                  <i className="menu-bullet menu-bullet-line">
                    <span></span>
                  </i>
                  <span className="menu-text">{submenuItem.name}</span>
                </Link>
              </li>
            )
          )}
        </ul>
      </div>
    </li>
  );
};

export default OneLevel;
